// Click action for a chat-message toast (subscribeRealtime.js's
// _notifyNewMessage: `action: { call: 'openChatFromToast', args: [channelId] }`).
// Opens the Messenger drawer straight to the channel/DM the message landed
// in. Mirrors messageUser.js and pageContext.js's 'channel' case (same
// activeChannelId/activeTab/activeThreadRootId triple) rather than
// introducing a fourth slightly-different "open a channel" implementation.
import { sameWorkspaceWriter } from './sameWorkspaceWriter.js'
export const openChatFromToast = async function (channelId) {
  if (!channelId) return
  // The toast can be clicked, the context fold awaited, and the workspace
  // switched before this resolves. `activeChannelId` / `activeThreadRootId`
  // are workspace-scoped, so selecting workspace A's channel inside workspace
  // B would point the whole chat pane at a channel B cannot read.
  const _write = sameWorkspaceWriter(this.state.root)
  // Bundle-fold: the MessengerOverlay (and the rest of the chat UI) lives in
  // the lazily-folded context — fold before flipping the drawer flag so the
  // overlay's if-latch can mount it.
  const ok = await this.call('ensureChatContext')
  if (ok === false) return
  _write({
    _chatDrawerOpen: true,
    activeChannelId: channelId,
    activeThreadRootId: null,
    activeTab: 'conversation'
  })
}
